module.exports = __webpack_public_path__ + "img/isoftbet.39afbf1a.svg";